// extracted by mini-css-extract-plugin
export default {"main":"auth_main__qSNlq","title":"auth_title__+e1TX"};